import { Flex, Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { formatDate } from '@blockpulse3/helpers';

type Props = {
  date: Date;
  validatorName?: string | undefined;
};

/**
 * SubscriptionValidated.
 * Displays the details of subscription validated activity.
 */
export function SubscriptionValidated({ date, validatorName }: Props): JSX.Element {
  const i18nSubscriberDetailsSidePanel = useTranslations('SubscriberDetailsSidePanel');

  return (
    <Stack spacing={1}>
      <Text fontSize="sm">
        {i18nSubscriberDetailsSidePanel('Activity.SubscriptionValidated.Title')}
      </Text>
      <Stack color="gray.500" spacing={1}>
        {validatorName && (
          <Flex justifyContent="space-between">
            <Text>
              {i18nSubscriberDetailsSidePanel('Activity.SubscriptionValidated.Validator')}:
            </Text>
            <Text>{validatorName}</Text>
          </Flex>
        )}
        <Flex justifyContent="space-between">
          <Text>{i18nSubscriberDetailsSidePanel('Activity.SubscriptionValidated.Date')}:</Text>
          <Text>{formatDate(date, 'DD/MM/YYYY')}</Text>
        </Flex>
      </Stack>
    </Stack>
  );
}
